<template>
  <div>
    <b-navbar toggleable="lg"  class=" navbar-expand-lg bg-white shadow-sm">
      <div class="container-fluid d-flex flex-column">
        
        <!-- Primera línea: Logo + Texto (columna para colocar el texto debajo del logo) -->
        <div class="d-flex flex-column align-items-center justify-content-center w-100 p-0">
          <!-- Logo más grande sin margen inferior -->
          <b-navbar-brand class="mb-0 d-flex flex-column flex-lg-row align-items-center">
            <div>
              <img src="../../assets/logo-color.png" class="list-social-icon img-fluid" style="width: 280px;">
            </div>
            <div>
              <span class="site-title ms-lg-5"> Desmitificando el Agile</span>
            </div>
          </b-navbar-brand>
          
          <b-navbar-toggle id="colapsoBoton" target="nav-collapse" class="d-lg-none"><span class="navbar-toggler-icon"></span></b-navbar-toggle>
        </div>

        <!-- Menú de navegación más arriba -->
        <b-collapse id="nav-collapse" is-nav class="w-100">
          <b-navbar-nav class="d-flex justify-content-center w-100">
            <b-nav-item class="nav-link active fw-bold" 
                        to="/"
                        data-bs-toggle="tooltip" 
                        title="Consulta el listado de todos los municipios disponibles.">
                        Inicio</b-nav-item>
            <b-nav-item class="nav-link active fw-bold" 
                        to="/acerca-de"
                        data-bs-toggle="tooltip" 
                        title="Acerca de Agile Sin Filtros.">
                        Acerca de Agile Sin Filtros</b-nav-item>
            <b-nav-item class="nav-link active fw-bold"
                         to="/pildoras"
                         data-bs-toggle="tooltip"
                         title="Píldoras Agile Sin Filtros.">
                         Píldoras</b-nav-item>
            <b-nav-item class="nav-link active fw-bold"
                         :to="{ name: 'BlogList' }"
                         data-bs-toggle="tooltip"
                         title="Nuestro Blog.">
                         Blog</b-nav-item>
            <b-nav-item class="nav-link active fw-bold"
                         to="/contacto"
                         data-bs-toggle="tooltip"
                         title="Contáctanos.">
                         Contáctanos</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>  
  </div>
</template>


<script>
export default {
  // No data, created, computed or methods needed for this static component
}
</script>

<style scoped>
@media (max-width: 768px) {
  .site-title {
    font-size: 2.0rem; /* Ajusta este valor según sea necesario */
  }
}
</style>
